import Vue from "vue";
import Vuex from "vuex";
import VuexPersistence from 'vuex-persist'
import calculate from "../calculate.js";

Vue.use(Vuex);
const vuexLocal = new VuexPersistence({
    storage: window.localStorage
})


export default new Vuex.Store({
    state: {
        cartItems: [],
        corporateCode: '',
        corporateDiscount: 0,
        shippingCost: 0
    },
    plugins: [vuexLocal.plugin],
    mutations: {
        addItem(state, newItem) {
            console.log(newItem);
            var x = state.cartItems;
            if (x.find((item) => item.id == newItem.id)) {
                x.find((item) => item.id == newItem.id).orderQty +=
                    newItem.orderQty;
                state.cartItems = x;
                return;
            }
            x.push(newItem);
            state.cartItems = x;

            console.log(state.cartItems);
        },
        removeFromCart(state, id) {
            state.cartItems.splice(
                state.cartItems.findIndex((item) => item.id == id),
                1
            );
        },
        emptyCart(state) {
            state.cartItems = [];
            state.corporateDiscount = 0;
            state.corporateCode = "";

        },
        incrementOrder(state, id) {
            var x = state.cartItems;
            x.find((item) => item.id == id).orderQty++;
            state.cartItems = x;
        },
        decrementOrder(state, id) {
            var x = state.cartItems;
            x.find((item) => item.id == id).orderQty--;
            state.cartItems = x;
        },
        shippingCost(state, value) {
            state.shippingCost = value;
        },
        corporateCode(state, value) {
            state.corporateCode = value;
        },
        corporateDiscount(state, value) {
            state.corporateDiscount = value;
        },
    },
    actions: {
        updateShippingCost(context) {

            Vue.prototype.$axios.get("calculate-shipping", { params: { total: context.getters.getOrderSubTotal } }).then(res => {
                context.commit('shippingCost', res.data.shipping_cost);
            });
        }

    },
    modules: {},
    getters: {
        getCorporateCode: (state) => {
            return state.corporateCode;

        },
        getCorporateDiscount: (state) => {
            return state.corporateDiscount;
        },
        getCartItemsCount: (state) => {
            return state.cartItems.length;
        },
        getCartItems: (state) => {
            return state.cartItems;
        },
        getOrderSubTotalOld: (state) => {
            var sum = 0;
            state.cartItems.forEach(
                (item) => {
                    let itemPrice = calculate(item.Price);
                    sum += itemPrice * item.orderQty;
                }
            );
            return calculate(sum);
        },

        getOrderSubTotal: (state, getters) => {
            var sum = 0;
            state.cartItems.forEach(
                (item) => {
                    if (!state.corporateDiscount) {
                        let itemPrice = calculate(item.Price * 1.12);
                        console.log(itemPrice);
                        sum += itemPrice * item.orderQty;
                    } else {
                        console.log(item.Price);
                        let itemPrice = calculate(item.Price - (getters.getCorporateDiscount * item.Price));
                        sum += (itemPrice * item.orderQty);
                    }
                }
            );
            return sum;
        },
        getOrderShipping: (state) => {
            return state.shippingCost;
        },
        getVat: (state, getters) => {
            return ((getters.getOrderSubTotal + getters.getOrderShipping) * 0.05);

        },
        getOrderTotal: (state, getters) => {
            if (!state.corporateDiscount) {
                return getters.getOrderSubTotal + getters.getOrderShipping + getters.getVat;
            } else {
                return getters.getOrderSubTotal + getters.getVat;
            }
        },
    },
});
